<template>
  <button 
    v-if="(!link)&&(!linkExterno)"
    class="border border-solid cursor-pointer rounded-full inline-block w-fit " 
    :class="mode"
    :disabled="disabled"
    :type="type"
  >
    <slot> </slot>
  </button>
  <a 
    v-else-if="archivo"
    :href="local ? publicPath+to : to" 
    :class="mode"
    class=" border border-solid cursor-pointer rounded-full inline-block w-fit " 
  >
    <slot> </slot>
  </a>
  <a 
    v-else-if="linkExterno" 
    :href="to" 
    :class="mode"
    class="border border-solid cursor-pointer rounded-full inline-block w-fit " 
  >
    <slot> </slot>
  </a>
  <router-link 
    v-else 
    :to="to" 
    :class="mode"
    class="border border-solid cursor-pointer rounded-full inline-block w-fit " 
  >
    <slot> </slot>
  </router-link>
</template>

<script>
export default {
  props: {
    link: {
      type: Boolean,
      required: false,
      default: false,
    },
    linkExterno: {
      type: Boolean,
      required: false,
      default: false,
    },
    to: {
      type: [Object, Array, String],
      required: false,
      default: () => {},
    },
    mode: {
      type: [String, Array],
      required: false,
      default: "",
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String,
      required: false,
      default: "button",
    },
    archivo: {
      type: Boolean,
      required: false,
      default: false,
    },
    local: {
      type: Boolean,
      required: false,
      default: true,
    }
  },
  data() {
      return {
        publicPath: process.env.BASE_URL
    }
  }, 
  created() {
    
  }
}
</script>

<style scoped>

.flat,
.title,
.icon {
  background-color: transparent;
  border: none;
  color:var(--fontColor);
  font-size: var(--fontSize);
}

.flat:disabled,
.title:disabled,
.icon:disabled {
  opacity: 0.5;
  cursor: unset;
}

.flat:disabled:hover,
.title:disabled:hover,
.icon:disabled:hover {
  background-color: transparent;
  border: none;
  color: var(--fontColor);
  font-size: var(--fontSize);
}

.title:hover,
.title:active {
  background-color: transparent;
  border: none;
}

.icon:hover {
  color: var(--backgroundHoverColor);
  background-color: transparent;
  border: none;
}

.outline {
  background-color: transparent;
  border-color: #410000;
  /* color: #410000; */
    color: var(--borderColor);
}

.flat:hover,
.flat:active,
.outline:hover,
.outline:active {
  /* background-color: #ffc6a4; */
  background-color: var(--backgroundHoverColor);
}
</style>
